import RemoveAttachmentsDialog from './RemoveAttachmentsDialog';

export default RemoveAttachmentsDialog;
